/** Query-key factory (doc 01 §8.1). Mutations invalidate by prefix. */

import type { TableState } from '@/hooks/useTableState'

export const qk = {
  datasets: (params?: TableState) => ['datasets', params] as const,
  dataset: (id: string) => ['datasets', id] as const,
  models: (params?: TableState) => ['models', params] as const,
  model: (id: string) => ['models', id] as const,
  adapters: () => ['adapters'] as const,
  capabilities: () => ['adapters', 'capabilities'] as const,
  metrics: (taskType?: string) => ['metrics', taskType ?? 'all'] as const,
  runs: (params?: TableState) => ['runs', params] as const,
  run: (id: string) => ['runs', id] as const,
  leaderboard: (id: string) => ['runs', id, 'leaderboard'] as const,
  runLogs: (id: string) => ['runs', id, 'logs'] as const,
  manifest: (id: string) => ['runs', id, 'manifest'] as const,
  health: () => ['system', 'health'] as const,
  info: () => ['system', 'info'] as const,
  providers: () => ['system', 'providers'] as const,
  defaults: () => ['system', 'defaults'] as const,
  me: () => ['auth', 'me'] as const,
  users: () => ['system', 'users'] as const,
} as const
